import { connect } from 'react-redux';

import { DaysMessage } from '../../creditUtilisation/creditLimit/daysMessage/index';
import { DecisionValidationTooltip } from '../../decisionValidityTooltip';
import styles from './ApprovalTimeout.module.css';
import { useQuery } from '@tanstack/react-query';
import { fetchGetFormalOffers } from '@iwoca/lapi-client/edge';
import FallbackErrorModal from '../../../modals/fallbackErrorModal/FallbackErrorModal';
import MainContentPending from '../../../pageStructure/mainContentPending';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = ({ siteContext }: RootState) => {
    return {
        stateKey: siteContext.impersonatingStateKey || siteContext.state_key
    };
};
type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const ApprovalTimeout = ({ stateKey }: PropsFromRedux) => {
    const {
        isLoading,
        isError,
        data: formalOfferTimeOutDate
    } = useQuery({
        queryKey: ['formal_offers', stateKey],
        queryFn: () => fetchGetFormalOffers({ stateKey: stateKey! }),
        select: (data) => data.data!.formal_offers[0].timeout
    });
    if (isLoading) {
        return <MainContentPending data-testid="approval-timeout-loading" />;
    }
    if (isError) {
        return <FallbackErrorModal />;
    }
    const timeoutDate: string = new Date(formalOfferTimeOutDate!).toISOString();
    const validForNumberOfDays = 14;

    return (
        <div
            className={styles.approvalTimeoutCell}
            data-testid="approval-timeout"
        >
            <p className={styles.timeoutMessageText}>
                <DaysMessage approvalStatusTimeOut={timeoutDate} />
                <DecisionValidationTooltip
                    className={styles.tooltip}
                    validForNumberOfDays={validForNumberOfDays}
                />
            </p>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ApprovalTimeout);
